import React, { useEffect } from "react";
import "./Navigation.css";
import { CATEGORIES } from "../../utils/constants";

const Navigation = ({ categories, selectedCategory, onSelectCategory }) => {
  const handleCategoryClick = (category) => {
    if (CATEGORIES.includes(category)) {
      onSelectCategory(category);
    }
  };

  useEffect(() => {
    if (CATEGORIES.includes(selectedCategory)) {
      localStorage.setItem("selectedCategory", selectedCategory);
    }
  }, [selectedCategory]);

  return (
    <div className="navigation">
      {categories.map((category) => (
        <div
          key={category}
          className={`navigation__item ${
            selectedCategory === category ? "navigation__item--active" : ""
          }`}
          onClick={() => handleCategoryClick(category)}
        >
          {category.toUpperCase()}
        </div>
      ))}
    </div>
  );
};

export default Navigation;
